import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Link, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { LanguageProvider, useLang } from "./i18n/LanguageContext";
import { AuthProvider } from "./auth/AuthContext";
import DemoLayout from "./demo/DemoLayout";
import { DemoHome, DemoDiscover } from "./demo/DemoHome";
import { DemoFollowing, DemoCollections, DemoMessages, DemoLive } from "./demo/DemoSocial";
import { DemoWallet, DemoProfile, DemoSecurity, DemoStudio } from "./demo/DemoAccount";
import { SmoothScroll } from "./components/SmoothScroll";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { AgeGate } from "./components/AgeGate";
import Landing from "./pages/Landing";
import Discover from "./pages/Discover";
import About from "./pages/About";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";
import Login from "./pages/Login";

const NotFound = () => {
  const { t } = useLang();
  return (
    <main data-testid="not-found-page" className="mx-auto max-w-7xl px-4 pb-28 pt-40 text-center">
      <p className="font-display text-7xl font-extrabold text-gradient">404</p>
      <h1 className="font-display mt-4 text-3xl font-bold text-ink">{t.notFound.title}</h1>
      <p className="mt-2 text-ink-2">{t.notFound.body}</p>
      <Link to="/" className="pill btn-primary mt-8 inline-flex px-6 py-3 text-sm font-semibold">{t.notFound.cta}</Link>
    </main>
  );
};

const Shell = () => {
  const { pathname } = useLocation();
  const inApp = pathname.startsWith("/app");
  return (
    <>
      <AgeGate />
      {!inApp && <Header />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/about" element={<About />} />
        <Route path="/legal" element={<Navigate to="/legal/terms" replace />} />
        <Route path="/legal/:slug" element={<Legal />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/app" element={<DemoLayout />}>
          <Route index element={<DemoHome />} />
          <Route path="discover" element={<DemoDiscover />} />
          <Route path="following" element={<DemoFollowing />} />
          <Route path="collections" element={<DemoCollections />} />
          <Route path="messages" element={<DemoMessages />} />
          <Route path="live" element={<DemoLive />} />
          <Route path="wallet" element={<DemoWallet />} />
          <Route path="profile" element={<DemoProfile />} />
          <Route path="security" element={<DemoSecurity />} />
          <Route path="studio" element={<DemoStudio />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!inApp && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <TooltipProvider delayDuration={100}>
            <BrowserRouter>
              <SmoothScroll>
                <Shell />
              </SmoothScroll>
            </BrowserRouter>
            <Toaster position="bottom-right" richColors />
          </TooltipProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
